import { useMemo, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { Printer, ArrowLeft, Plus } from "lucide-react";
import { ASSETS } from "@/data/assets";

const FRONTS = [ASSETS.centerpiece, ASSETS.flashProcess, ASSETS.party1, ASSETS.party2];
const DEFAULT_REFS = "bar-frenchmen, coffee-shop, salon, boutique, creator-01";

export default function DropCards() {
  const [raw, setRaw] = useState(DEFAULT_REFS);
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  const cards = useMemo(() => {
    return raw.split(",").map((s) => s.trim()).filter(Boolean).map((code, i) => ({
      code: code.toLowerCase().replace(/\s+/g, "-"),
      front: FRONTS[i % FRONTS.length],
    }));
  }, [raw]);

  return (
    <div className="min-h-screen bg-[#090909] text-[#F5F0E8] print:bg-white">
      {/* Controls (hidden on print) */}
      <div className="sticky top-0 z-10 max-w-full overflow-x-clip border-b border-white/10 bg-[#090909]/90 px-4 py-5 backdrop-blur-xl print:hidden sm:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm text-[#F5F0E8]/60 hover:text-[#F5F0E8]">
                <ArrowLeft size={14} /> Back to dashboard
              </Link>
              <h1 className="font-display text-3xl tracking-tighter mt-1">QR Drop Cards</h1>
              <p className="text-[#F5F0E8]/50 text-sm mt-1">"Who left this Foto?" guerrilla cards. Each ref tag is tracked to sales in your dashboard.</p>
            </div>
            <button data-testid="print-cards" onClick={() => window.print()}
              className="flex w-full min-w-0 items-center justify-center gap-2 rounded-full bg-[#39E75F] px-5 py-3 font-accent text-[#090909] glow-hover hover:bg-[#5cff7e] sm:w-auto sm:px-6">
              <Printer size={16} /> PRINT / SAVE PDF
            </button>
          </div>
          <div className="mt-4">
            <label className="font-accent tracking-widest text-xs text-[#F5F0E8]/50 flex items-center gap-2">
              <Plus size={12} /> CAMPAIGN / FLYER TAGS (comma-separated — one card per tag)
            </label>
            <textarea data-testid="ref-input" value={raw} onChange={(e) => setRaw(e.target.value)}
              rows={2}
              className="w-full mt-2 bg-transparent border border-white/15 rounded-md p-3 text-sm focus:outline-none focus:border-[#39E75F]" />
            <p className="text-xs text-[#F5F0E8]/40 mt-1">{cards.length} card{cards.length !== 1 ? "s" : ""} — each QR points to {origin}/?ref=&lt;tag&gt;</p>
          </div>
        </div>
      </div>

      {/* Printable cards */}
      <div className="max-w-5xl mx-auto p-6 print:p-0">
        <div className="grid min-w-0 grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-6 print:grid-cols-2">
          {cards.map((c, i) => (
            <div key={c.code} className="space-y-3 break-inside-avoid" data-testid={`card-${c.code}`}>
              {/* FRONT */}
              <div className="float-img bg-[#F5F0E8] p-2.5 pb-8 shadow-xl" style={{ "--float-delay": `${-(i % 6) * 0.8}s` }}>
                <div className="aspect-[4/5] overflow-hidden bg-black">
                  <img src={c.front} alt="" className="w-full h-full object-cover" />
                </div>
                <p className="text-center font-accent tracking-[0.3em] text-[#090909] text-xs pt-2">POLE &amp; POLAROIDS</p>
              </div>
              {/* BACK */}
              <div className="bg-[#090909] border border-black p-4 flex flex-col items-center text-center aspect-[4/5] justify-center">
                <p className="font-display italic text-2xl leading-tight text-[#F5F0E8]">Who left<br />this Foto?</p>
                <div className="bg-white p-2 rounded mt-3">
                  <QRCodeSVG value={`${origin}/?ref=${encodeURIComponent(c.code)}`} size={104} level="M" />
                </div>
                <p className="font-accent tracking-widest text-[#39E75F] text-xs mt-3">POLE &amp; POLAROIDS — SEPT 25</p>
                <p className="font-accent tracking-widest text-[#F5F0E8]/40 text-[10px] mt-1">SCAN · {c.code}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
